export function getModelPricingTiers(model) {
    if (Array.isArray(model?.pricing)) {
        return model.pricing;
    }

    return model?.pricing ? [model.pricing] : [];
}

export function matchesOutputPriceFilter(model, filter) {
    if (!filter) {
        return true;
    }

    const outputPrices = getModelPricingTiers(model)
        .map(tier => tier.outputPerMillionTokens)
        .filter(price => price != null);

    if (outputPrices.length == 0) {
        return false;
    }

    return outputPrices.some(outputPrice => {
        if (filter === "cheapest") {
            return outputPrice >= 0 && outputPrice <= 0.5;
        }

        if (filter === "cheap") {
            return outputPrice > 0.5 && outputPrice <= 1;
        }

        if (filter === "midrange") {
            return outputPrice > 1 && outputPrice <= 3;
        }

        if (filter === "costly") {
            return outputPrice > 3 && outputPrice <= 15;
        }

        if (filter === "expensive") {
            return outputPrice > 15;
        }

        return true;
    });
}